 export const AuthenticationContent={
    EmployeeID:"Employee ID",
    Password:"Password",
    ForgotPassword:"Forgot Password",
    Login:"Login",
    NewEmployRegistration:"New Employ Registration",
    EmployInfo:"Employ's Info",
    Employee:"Employee"


}

export const RegistrationContent={
    RegisterNow:"Register Now !",
    FirstName:"First Name:",
    LastName:"Last Name:",
    SelectYourDesignation :"Select Your Designation :",
    DesignationList:["Choose","Sr.Bench Sales Recruiters","Bench sales recruiter","OPT recruiter","WebDeveloper"],
    DateofJoining:"Date of Joining:",
    Email:"Email:",
    Password:"Password:",
    ReEnterPassword:"Re-EnterPassword:",
    Register:"Register",
    }

    export const ResetPasswordContent={
        EnterYourRegisterdEmail:"Enter Your Registerd Email",
        Submit:"Submit",
        EnterOTP:"Enter OTP",
        VerifyYourOTP:"Verify Your OTP",
        EnteryourNewPassword:"Enter your New Password"

    }